import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit'
import {combineReducers} from "redux";
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import {FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE} from 'redux-persist'

import appReducer from './lib/slices/appSlice'
import imageReducer from './lib/slices/imageSlice'


const reducers = combineReducers({
  app: appReducer,
  image: imageReducer,
})

const persistConfig = {
  key: 'oledonline',
  whitelist: [],
  //blacklist: [],
  storage,
}
const persistedReducer = persistReducer(persistConfig, reducers)

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
    }
  })
})
let persistor = persistStore(store);

export {
  store,
  persistor,
};


